// Use relative URL in development so Vite proxy handles CORS, or use env variable for production
const appUrl: string = import.meta.env.VITE_APP_API_URL || '';
export const deployedUrl = `${window.origin}/`; // used by deployment scripts

interface ApiConfigShape {
  [key: string]: string;
}

export const ApiConfig: ApiConfigShape = {
  // =========EndPoints========== //
  getcode: 'verify-otp',
  login: "login",
  googleLogin: 'google',
  overview: 'overview',
  metric: 'metric',
  // Price targets & valuation
  priceTargetsNextYearBlended: 'price-targets/next-year/blended',
  priceTargetsNextYear: 'price-targets/next-year',
  analystRatingsHistory: 'price-targets/ratings-history',
  analystEstimates: 'price-targets/analyst-projections',
  analystDashboard: 'price-targets/price-target-table',
  analystPriceTargetTable: 'price-targets/price-target-table',
  marketSegmentDetails: 'market-segment-details',
  stockSymbols: 'stock-symbols',
  stockSymblosIR: 'stock-symbols-ir',
  stockSymblosSearch: 'stock-symbols/search',
  balanceSheetBreakdown: 'balance-sheet/breakdown',

  balanceSheetHistory: 'balance-sheet/enhanced-unified',
  incomeStamentBreakdown: 'breakdown',
  analystForecasts: 'analyst-forecasts',
  getRecentEarningsAIReport: 'get-recentearnings-ai-report',
  incomeEnhancedHistory: 'enhanced-unified',
  cashflowBreakdown: 'breakdown',
  cashflowHistory: 'enhanced-unified',
  lifetimeMetrics: 'lifetime-metrics-value',
  metrics: 'metrics',
  metricKeys: 'metrics/metric-keys',
  metricValuesTrend: 'metrics/by-key-parameter',
  getEarningCalls: 'earnings/get-earnings',
  getSecFiles: 'sec-files/search-html-content',
  getUserData: 'getuserinfo',
  subscriptionConfig: 'subscriptionConfig',
  stockResearchSave: 'save',
  stockResearchFindBySymbol: 'symbol',


  companyPerformanceSnapshot: 'valuation/company-performance-snapshot',
  sharePriceSeries: 'valuation/share-price-series',
  businessModel: 'businessModel',
  swotAnalysis: 'swot',

  // Save Stock Research Data
  stockResearchData: 'stock-research',
  stockResearchDashboard: 'stock-research/dashboard',
  metricCategories: 'metrics/categories',
  metricsByCategory: 'metrics/category',
  metricsBySubCategory: 'metrics/subcategory',
  checkout: 'checkout',
  products: 'products',
  verifyTransaction: 'verify-transaction',
  cancelSubscription: 'cancel-subscription',
  cancelSubscriptionImmediate: 'cancel-subscription-immediately',
  chartTimeSeries: 'chart/time-series',
  // Market movers
  marketMovers: 'market-movers',
  topGainers: 'market-movers/gainers',
  topLosers: 'market-movers/losers',

  // Hall of Fame - Stock Influencer Tracker
  hallOfFameLeaderboard: 'hall-of-fame/leaderboard',
  hallOfFameSubmit: 'hall-of-fame/submit',
  hallOfFameParticipant: 'hall-of-fame/participant',
  hallOfFamePerformance: 'hall-of-fame/performance',
  hallOfFameValidate: 'hall-of-fame/validate-tickers',

  // ============URLs================ //
  baseUrl: `${appUrl}/`,
  appUrl: `${appUrl}/`,
  apiUrl: `${appUrl}/api/`,
  baseAuth: `${appUrl}/api/auth/`,
  aiUrl: `${appUrl}/api/ai/`,
  earningsUrl: `${appUrl}/earnings/`,
  incomeStatementUrl: `${appUrl}/api/income-statement/`,
  cashflowUrl: `${appUrl}/api/cash-flow/`,
  stockResearchUrl: `${appUrl}/api/stock-research/`,
  billingUrl: `${appUrl}/api/billing/`,
  newsletter: '/api/newsletter/subscribe',

  // Super Investors / Fund Insights Endpoints
  superInvestorsByRank: 'institutional-ownership/super-investors-by-rank',
  aumLeaderboard: 'institution-home/aum-leaderboard',

  // Institutional Ownership Endpoints
  topByReducedPositions: 'institutional-ownership/top-by-reduced-positions',
  topByPutOptions: 'institutional-ownership/top-by-put-options',
  topByNewPositions: 'institutional-ownership/top-by-new-positions',
  topByIncreasedPositions: 'institutional-ownership/top-by-increased-positions',
  topByFundsHolding: 'institutional-ownership/top-by-funds-holding',
  topByClosedPositions: 'institutional-ownership/top-by-closed-positions',
  topByCallOptions: 'institutional-ownership/top-by-call-options',

  // Symbol Specific Institutional Data
  institutionalOwnershipHistory: 'institutional-ownership/history',
  institutionalTopBuyers: 'institutional-ownership/top-buyers',
  institutionalTopSellers: 'institutional-ownership/top-sellers',
  institutionalHoldings: 'institutional-ownership/holdings',

  // Institution Portfolio Endpoints (CIK-based)
  institutionPortfolioSummary: 'institutional-ownership/portfolio-summary',
  institutionPortfolioWithChanges: 'institutional-ownership/portfolio-with-changes',
  institutionTopBuys: 'institutional-ownership/portfolio/top-buys',
  institutionTopSells: 'institutional-ownership/portfolio/top-sells',
};